<template><div><h1>VUX V2.5.12 发布日志</h1>
<h2><a href="/zh-CN/components/form-preview.html">FormPreview</a></h2>
<ul><li>[fix] 修复 header-value 为空时的错位问题 #1935</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 支持 switchViewToToday, switchViewToMonth 等手动渲染方法</li>
<li>[feature] 支持事件 on-view-change，方便切换月份时请求数据</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 在 beforeDestroy 和 deactivated 事件中清除设置于 body 上的 vux-modal-open 类名 #1921</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[change] 属性 scroll 已经废弃，仅对配置为 100% 布局的情况实现阻止滚动 #1858 #1877</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复多次调用重复显示的问题 #1927</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.12 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.12-243.vue?d1908dd6